import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { GeneralLayout, LayoutProps } from './GeneralLayout';
import { GeneralLayoutV2 } from './GeneralLayoutV2';

export function GeneralLayoutVersion(props: LayoutProps) {
  const isV2 = useFeatureIsOn('feature.ecom2.spa-days');
  if (isV2) return <GeneralLayoutV2 {...props} />;
  return <GeneralLayout {...props} />;
}
